import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { ClipboardTextIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import {
  useGetTransportsQueryWithPolling,
  useSeenTransportIds,
  initializeSeenTransports,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import {
  ListHeaderRow,
  EmptyStateBox,
  HeaderActions,
  ListPanelContent,
  EmptyStatePadding,
  PanelHeaderRow,
  PanelHeaderTitle,
  NewRequestButton,
} from './RequestListView.styles';
import TransportListItem from './TransportListItem';

interface RequestListViewProps {
  onNewRequest: () => void;
  onSelectTransport: (id: string) => void;
}

function RequestListView({
  onNewRequest,
  onSelectTransport,
}: RequestListViewProps) {
  const dispatch = useDispatch();
  const { data } = useGetTransportsQueryWithPolling();
  const seenTransportIds = useSeenTransportIds();
  const initializedRef = useRef(false);

  const transports = data?.transports;

  useEffect(() => {
    if (transports && transports.length > 0 && !initializedRef.current) {
      initializedRef.current = true;
      const ids = transports.map(t => t.gmr_transport_id);
      dispatch(initializeSeenTransports(ids));
    }
  }, [transports, dispatch]);

  return (
    <>
      <PanelHeaderRow>
        <PanelHeaderTitle>
          <ClipboardTextIcon width={16} height={16} color="primaryText" />
          <Text
            color="primaryText"
            size="large"
            fontWeight="bold"
            data-name="resource-panel-title"
          >
            Resources & Tools
          </Text>
        </PanelHeaderTitle>
      </PanelHeaderRow>
      <ListHeaderRow>
        <Text
          color="secondaryText"
          size="normal"
          data-name="resource-panel-title"
        >
          Resource Requests
        </Text>
        <HeaderActions>
          <NewRequestButton
            btnType="primary"
            size="small"
            noMargin
            onClick={onNewRequest}
            dataName="resource-panel-new-request-button"
          >
            + New Request
          </NewRequestButton>
        </HeaderActions>
      </ListHeaderRow>
      <ListPanelContent>
        {!transports || transports.length === 0 ? (
          <EmptyStatePadding>
            <EmptyStateBox>
              <Text color="secondaryText" size="normal">
                No Resource Requests available
              </Text>
            </EmptyStateBox>
          </EmptyStatePadding>
        ) : (
          transports.map(transport => (
            <TransportListItem
              key={transport.gmr_transport_id}
              transport={transport}
              isUnread={!seenTransportIds.includes(transport.gmr_transport_id)}
              onClick={() => onSelectTransport(transport.gmr_transport_id)}
            />
          ))
        )}
      </ListPanelContent>
    </>
  );
}

export default RequestListView;
